import { useSelector } from 'react-redux';

export const getFeatureFlags = (state) => {
  const { features, hasRequestSucceeded: hasLoaded } = state.featureToggle;

  return {
    features,
    loading: !hasLoaded,
    refreshAvailabilityCalendarFlagIsEnabled: true,
    refreshSearchRevampFlagIsEnabled: true,
    infiniteLoadingFixFlagIsEnabled: true,
  };
};

export const useFeatureFlags = () => {
  return useSelector(getFeatureFlags);
};
